import {
  Modal,
  ModalCloseIconButton,
  ModalContent,
  ModalTitle,
  Typography,
  Icon,
} from '@ace-clublabs/shared-component-library';

export interface GreenBoxModalProps {
  showGreenBoxModal: boolean;
  modalTitle: string;
  modalContent: string;
  closeModal: () => void;
}

export const GreenBoxModal: (props: GreenBoxModalProps) => JSX.Element = (props) => (
  <Modal
    className="green-box-modal"
    open={props.showGreenBoxModal}
    size="medium"
    onClose={() => {
      props.closeModal();
    }}
  >
    <ModalTitle id="greenBoxModalTitle" sx={{ marginRight: '2rem', display: 'flex' }}>
      <Icon
        iconName="tags-duotone"
        sx={{ color: '#4F8C24', alignSelf: 'center', fontSize: '20px' }}
        className="benefit-coupon-icon green-box-title-icon"
      ></Icon>
      <Typography variant="h5">{props.modalTitle}</Typography>
      <ModalCloseIconButton
        aria-label="Close"
        onClick={() => {
          props.closeModal();
        }}
      />
    </ModalTitle>

    <ModalContent id="modal-content-remove">
      <Typography variant="b1Regular" sx={{ marginBottom: '1rem' }}>
        {props.modalContent}
      </Typography>
    </ModalContent>
  </Modal>
);
